import React, {useEffect} from 'react';
import {importFontello} from '../../../Common/Fonts/fonts.js';
import {usePollFonts} from '../../../Common/React/lib/contexts/PollContext.js';

export const Survey = () => {
    usePollFonts();

    useEffect(() => {
        importFontello();
        
        const json = {
            message: 'reload iframeresizer',
        };

        setTimeout(function () {
            window.top.postMessage(JSON.stringify(json), '*');
        }, 200);

    }, []);

    return <span id={'survey-content'}/>;
};